import * as Sentry from "@sentry/react";

/**
 * Initializes Sentry for the browser, if a DSN is configured. Deliberately
 * a silent no-op (not even a console warning) when VITE_SENTRY_DSN isn't
 * set -- e.g. in local dev, or before the Sentry project has actually been
 * created -- so error monitoring is additive and never blocks running the
 * app without it configured.
 */
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // Conservative starting point for performance tracing -- 10% of
    // sessions. Tune once real traffic volume/patterns are known; this is
    // primarily here for error reporting, performance data is a bonus.
    tracesSampleRate: 0.1,
  });
}
